/** The dashboard: the overview of all sites — English, the source of the other languages */
const dashboard = {
  "dashboard.greeting.morning": "Good morning, {name}",
  "dashboard.greeting.afternoon": "Good afternoon, {name}",
  "dashboard.greeting.evening": "Good evening, {name}",
  "dashboard.subtitle": "Network overview across all your sites",
  "dashboard.totalSites": "Total Sites",
  "dashboard.acrossAllSites": "Across all sites",
  "dashboard.connectedNow": "Connected now",
  "dashboard.activeAlerts": "Active Alerts",
  "dashboard.throughput": "Network Throughput",
  "dashboard.averageOver": "average over {period}",
  "dashboard.download": "↓ Download",
  "dashboard.upload": "↑ Upload",
  "dashboard.allSitesNote": "All sites together. Per-site history is on each site's page.",
  "dashboard.recentAlerts": "Recent Alerts",
  "dashboard.allAlerts": "All alerts",
  "dashboard.noAlerts": "No active alerts — all systems healthy",
  "dashboard.trafficSummary": "Traffic Summary",
  "dashboard.totalReceived": "Total received",
  "dashboard.totalSent": "Total sent",
  "dashboard.slowestSite": "SLOWEST SITE",
  "dashboard.avg": "{rate} avg",
}

export default dashboard
